import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { appendTeamMemberLawyerId } from "../../../styles/styles";

export const createCustomField = createAsyncThunk(
  "createCustomField",
  async ({ url, body, token }) => {
    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      toast.error("Failed to create custom field");
      throw error.response?.data || error.message;
    }
  }
);

export const getAllCustomField = createAsyncThunk(
  "getAllCustomField",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);

      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      toast.error("Failed to fetch custom fields");
      throw error.response?.data || error.message;
    }
  }
);

export const updateCustomField = createAsyncThunk(
  "updateCustomField",
  async ({ url, body, token }, { rejectWithValue }) => {
    try {
      const response = await axios.put(url, body, {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const customFieldSlice = createSlice({
  name: "customField",
  initialState: {
    allCustomField: null,
    customFieldPagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    loadingCustomField: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCustomField.pending, (state) => {
        state.loadingCustomField = true;
        state.error = null;
      })
      .addCase(createCustomField.fulfilled, (state) => {
        state.loadingCustomField = false;
      })
      .addCase(createCustomField.rejected, (state, action) => {
        state.loadingCustomField = false;
        state.error = action.payload || "Failed to create custom field";
      })
      .addCase(getAllCustomField.pending, (state) => {
        state.loadingCustomField = true;
        state.error = null;
      })
      .addCase(getAllCustomField.fulfilled, (state, action) => {
        state.loadingCustomField = false;
        state.allCustomField = action?.payload?.results;
        state.customFieldPagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllCustomField.rejected, (state, action) => {
        state.loadingCustomField = false;
        state.error = action.payload || "Failed to fetch custom fields";
      })
      .addCase(updateCustomField.pending, (state) => {
        state.loadingCustomField = true;
        state.error = null;
      })
      .addCase(updateCustomField.fulfilled, (state, action) => {
        state.loadingCustomField = false;
        state.allCustomField = action.payload;
      })
      .addCase(updateCustomField.rejected, (state, action) => {
        state.loadingCustomField = false;
        state.error = action.payload || "Failed to fetch custom fields";
      });
  },
});

export const CustomFieldReducer = customFieldSlice.reducer;

